import { MatSnackBar } from '@angular/material/snack-bar';
import { getErrorCode } from '@core/utils/get-error-code';
import { TranslateService } from '@ngx-translate/core';
import { sentry } from 'sentry';
import { FuseTranslationLoaderService } from '../../../@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { KNOW_ERRORS } from './know-errors';
import * as i0 from "@angular/core";
import * as i1 from "../../../@fuse/services/translation-loader.service";
import * as i2 from "@angular/material/snack-bar";
import * as i3 from "@ngx-translate/core";
var MessageService = /** @class */ (function () {
    function MessageService(fuseTranslationLoaderService, snackBar, translateService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.snackBar = snackBar;
        this.translateService = translateService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    /**
     * @deprecated Use CustomMessagesService instead
     */
    MessageService.prototype.success = function (key, interpolateParams) {
        var message = this.translateService.instant(key, interpolateParams);
        this.snackBar.open(message, null, {
            duration: 5000,
            horizontalPosition: 'left'
        });
    };
    /**
     * @deprecated Use CustomMessagesService instead
     */
    MessageService.prototype.warn = function (key, interpolateParams) {
        var message = this.translateService.instant(key, interpolateParams);
        this.snackBar.open(message, null, {
            duration: 5000,
            horizontalPosition: 'left'
        });
    };
    /**
     * @deprecated Use CustomMessagesService instead
     */
    MessageService.prototype.error = function (err, errTranslatedKey) {
        var code = getErrorCode(err);
        var key = KNOW_ERRORS[code] || errTranslatedKey || 'ERRORS.UNKNOWN';
        if (!KNOW_ERRORS[code]) {
            sentry.captureException(err);
        }
        var message = this.translateService.instant(key);
        this.snackBar.open(message, null, {
            duration: 5000,
            horizontalPosition: 'left'
        });
    };
    MessageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MessageService_Factory() { return new MessageService(i0.ɵɵinject(i1.FuseTranslationLoaderService), i0.ɵɵinject(i2.MatSnackBar), i0.ɵɵinject(i3.TranslateService)); }, token: MessageService, providedIn: "root" });
    return MessageService;
}());
export { MessageService };
